import { useEffect, useState } from "react";
import { Autocomplete } from "@mui/material";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import cn from "classnames";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
	addFieldToConnectorSetting,
	changeFieldNameInConnectorSettings,
	changeConnectorSettingValue,
	deleteFieldToConnectorSetting,
} from "@/store/ses/sesConnectorSlice";
import { selectEndpointList } from "@/store/ses/sesEndpointSlice";
import { useTranslate } from "@/hooks";
import { colorRed } from "@/constants/colors";
import { IFieldValueBlockProps } from "./FieldValueBlock.props";
import styles from "./FieldValueBlock.module.scss";
import { RenderOption, CustomTextField, ButtonIcon } from "@/ui";

const FieldValueBlock = ({ channel, setting, field, fieldLabel, value, valueLabel, idx, array, changeFlgHandler, isDisabled }: IFieldValueBlockProps): JSX.Element => {
	const [inputField, setInputField] = useState<string>(""); // переменная
	const [inputValue, setInputValue] = useState<string>(""); // значение

	const dispatch = useAppDispatch();
	const endpointList = useAppSelector(selectEndpointList); // список КТ

	const translate = useTranslate(); // hook для перевода текста

	// следим за начальными состояниями и вписываем
	useEffect(() => {
		setInputField(field);
		setInputValue(value);
	}, [field, value]);

	// обработчик сохранения названия переменной
	const variableNameSaveHandler = (): void => {
		if (field === inputField) return;
		dispatch(changeFieldNameInConnectorSettings({ channel, setting, oldName: field, newName: inputField }));
		changeFlgHandler("params");
	};

	// обработчик сохранения значения переменной
	const variableValueSaveHandler = (): void => {
		if (value === inputValue) return;
		dispatch(changeConnectorSettingValue({ channel, setting, field: inputField, value: inputValue }));
		changeFlgHandler("params");
	};

	// обработчик удаления
	const deletionHandler = (): void => {
		dispatch(deleteFieldToConnectorSetting({ channel, setting, field: inputField }));
		changeFlgHandler("params");
	};

	return (
		<div
			className={cn(styles.block, {
				[styles.blockOpacity]: array.length - 1 === idx,
				[styles.blockHidden]: array.length - 1 === idx && isDisabled,
			})}
		>
			{/* поле */}
			<Autocomplete
				fullWidth
				freeSolo
				autoHighlight
				options={setting === "variables" ? endpointList.variableNames : []}
				value={inputField}
				onChange={(_, value) => {
					if (array.length - 1 === idx && value) dispatch(addFieldToConnectorSetting({ channel, setting, field: inputField }));
					setInputField(value || "");
				}}
				disabled={isDisabled}
				renderInput={(params) => (
					<CustomTextField
						{...params}
						placeholder={translate(fieldLabel)}
						value={inputField}
						onChange={(e) => {
							if (array.length - 1 === idx) dispatch(addFieldToConnectorSetting({ channel, setting, field: inputField }));
							setInputField(e.target.value);
						}}
						onBlur={variableNameSaveHandler}
						error={!inputField && array.length - 1 !== idx}
					/>
				)}
				renderOption={(props, option) => {
					return (
						<RenderOption {...props} key={option}>
							{option}
						</RenderOption>
					);
				}}
			/>

			{setting === "variables" && <div className={styles.equals}>=</div>}

			{/* значение */}
			<Autocomplete
				fullWidth
				freeSolo
				autoHighlight
				options={setting === "variables" ? endpointList.variableValues : []}
				value={inputValue}
				onChange={(_, value) => setInputValue(value || "")}
				disabled={isDisabled || !inputField}
				renderInput={(params) => (
					<CustomTextField
						{...params}
						placeholder={translate(valueLabel)}
						value={inputValue}
						onChange={(e) => setInputValue(e.target.value)}
						onBlur={variableValueSaveHandler}
						error={!inputValue && array.length - 1 !== idx}
						// InputProps={{
						// 	...params.InputProps, // важно прокинуть параметры
						// 	endAdornment: (
						// 		<InputAdornment position="end">
						// 			{isAccess(SES.CONNECTOR_MODIFY) && activeRobotVersion !== "backup" && array.length > 1 && array.length - 1 !== idx && (
						// 				<div className={styles.deleteButton}>
						// 					<FontAwesomeIcon
						// 						icon={faTrashCan}
						// 						color={colorRed}
						// 						size="sm"
						// 						onClick={deletionHandler}
						// 						title={translate("button_delete")}
						// 						style={{ cursor: "pointer" }}
						// 					/>
						// 				</div>
						// 			)}
						// 			{params.InputProps.endAdornment} {/* важно дописать параметры */}
						// 		</InputAdornment>
						// 	),
						// }}
					/>
				)}
				renderOption={(props, option) => {
					return (
						<RenderOption {...props} key={option}>
							{option}
						</RenderOption>
					);
				}}
			/>

			{!isDisabled && array.length > 1 && (
				<ButtonIcon
					className={array.length - 1 === idx ? styles.deleteButtonHidden : undefined}
					icon={faTrashCan}
					iconSize="sm"
					iconColor={colorRed}
					onClick={deletionHandler}
					title={translate("button_delete")}
				/>
			)}
		</div>
	);
};

export default FieldValueBlock;
